import { render, staticRenderFns } from "./contactFormDialog.vue?vue&type=template&id=1318cc18&scoped=true&"
import script from "./contactFormDialog.vue?vue&type=script&lang=js&"
export * from "./contactFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318cc18",
  null
  
)

export default component.exports